import { globalGetService, globalPostService } from '@/utils/globalApiServices';
import { CreateAppealParams } from './types';

export const createAppeal = async (
  brandId: string,
  vettingClass: 'asset' | 'identity' | 'standard' | 'rcs' | 'authplus',
  data: CreateAppealParams
) => {
  const response = await globalPostService(
    `csp/vetting/appeal/brand/${brandId}/${vettingClass}`,
    data
  );
  if (response?.ok) return response?.data;
  throw new Error('Failed to create appeal');
};

export const getAppeals = async (
  brandUid: string,
  params: Record<string, unknown>
) => {
  const response = await globalGetService('csp/vetting/appeal', {
    brandUid,
    ...params,
  });
  return response?.ok ? response?.data.records : [];
};
